// extracted by mini-css-extract-plugin
export default {"container":"Ld_GH","content":"l69AH","closeButton":"a874X"};